// extracted by mini-css-extract-plugin
module.exports = {"wordGroup":"index-wordGroup_2BlaI","wordGroupContainer":"index-wordGroupContainer_3wRZ2"};